module.exports = __webpack_public_path__ + "static/media/menu.166a176e.svg";